import { IDataStorage } from '../internal/data-storage';
import { InternalTable } from '../internal/internal-table';
import { InternalIndex } from '@stockcare-storage/internal/internal-index';
import { ServiceCategory } from '@stockcare-models/ServiceCategory';

export class Service implements IDataStorage {
  index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('Services', 'Id', true, [
    this.index
  ]);

  Id: number;
  ReferenceId: string;
  CreatedTime: Date;
  CreatedByUserId: string;
  Name: string;
  UpdatedTime: any;
  UpdatedByUserId: string;
  InstitutionId: number;
  ServiceId: number;
  ServiceCategory: ServiceCategory;
  Quantity: number;
  Barcode: string;
  UnitOfMeasure: string;

  static getTableDefinition(): InternalTable {
    return new Service().tableDefinition;
  }
}
